import { format, parseISO } from 'date-fns';
import { Row } from '@tanstack/react-table';
import { PromoCode } from 'models/PromoCode';

interface ValidDatesCellProps {
  row: Row<PromoCode>;
}

const ValidDatesCell = ({ row }: ValidDatesCellProps) => {
  const { validFromUTCDateTime, validToUTCDateTime } = row.original;

  const fromDate = parseISO(validFromUTCDateTime);
  const toDate = parseISO(validToUTCDateTime);

  return `${format(fromDate, 'yyyy-MM-dd')} - ${format(toDate, 'yyyy-MM-dd')}`;
};

export default ValidDatesCell;
